// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1USyjm_m","form":"_19Z9cyk2","params":"_3juiGRW_","title":"_2sN2h_HU","darker":"_3Rp5t93B","lighter":"_1nS2NgZs","textarea":"BkKLJhWc","complementary":"_3OfoEy4j","selected":"V43TVVQJ","lists":"_1zaQMHcT","effort":"_3r2swlIG","box":"_1tiehIIb","save":"_3NpPjaXa"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/StravaListData/StravaListData.styl
// module id = 394
// module chunks = 0